import { render, staticRenderFns } from "./ImgVideoLightBox.vue?vue&type=template&id=85458c9e"
import script from "./ImgVideoLightBox.vue?vue&type=script&lang=js"
export * from "./ImgVideoLightBox.vue?vue&type=script&lang=js"
import style0 from "./ImgVideoLightBox.vue?vue&type=style&index=0&id=85458c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports